import { Api, Config } from './api'

export const ApiObterPatios = async (filtros) => {
   const params = new URLSearchParams()

   if (filtros.pagina) {
      params.append('pagina', filtros.pagina)
   }

   if (filtros.limite) {
      params.append('limite', filtros.limite)
   }

   if (filtros.dataAtividade) {
      params.append('dataAtividade', filtros.dataAtividade)
   }

   const { data } = await Api.get(`/patios`, Config(params))

   return data
}
